import React from 'react';

export const LoaderComponent = () => (
  <div className="overlay d-flex p-1 justify-content-center">
    <i className="pi pi-spin pi-spinner" style={{ fontSize: '1em' }}></i>
  </div>
);
